<template>
  <div>
    <template v-if="!storeState.gotBlock || !storeState.dbMeta">
      <v-row>
        <v-col cols="12" sm="12" class="text-center">
          <v-progress-circular
            indeterminate
            :size="100"
            :width="8"
            color="primary"
            class="justify-center align-center"
          >
          </v-progress-circular>
        </v-col>
      </v-row>
    </template>
    <template v-else-if="storeState.noAccess">
      <div class="no-access">
        <h4> You don't have access to this block 😢, contact your team admin to get it.
          <button @click="store.getHelp" class="btn-link"> Click here to get help.</button>
        </h4>
      </div>
      <div class="no-access">
        <h4> You can also <button @click="newBlock" class="btn-link"> create your own block here</button>
        </h4>
      </div>
    </template>
    <div v-else ref="tables">
      <div class="sidebar-menu-icon-container">
        <v-icon @click="showSidebar=true">mdi-menu</v-icon>
      </div>
      <div class="sidebar-menu-container">
        <v-navigation-drawer
          v-model="showSidebar"
          :expand-on-hover="false"
          width="500"
          absolute
        >
          <v-list
            dense
            nav
            class="py-0"
          >
            <v-row>
              <v-col cols="12" sm="2" md="2" class="text-left clickable" @click="storeState.cmdkActive=true;showSidebar=false;">
                <v-avatar>
                  <img :src="storeState.settings.user.me.pic">
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="8" md="8" class="text-left clickable" @click="storeState.cmdkActive=true;showSidebar=false;">
                <div>{{storeState.settings.user.me.email}}</div>
                <div>{{storeState.settings.user.me.name}}</div>
              </v-col>
              <v-col cols="12" sm="2" md="2" class="text-right clickable" @click="showSidebar=false;">
                <v-icon large>mdi-chevron-left</v-icon>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-list-item>
              <v-row 
                no-gutters 
                class="block-detail-row"
              >
                <v-col cols="12" sm="3" md="3">
                  <div class="auto-prepend-label">
                    <v-icon small class="dest-type-icon">mdi-database</v-icon>
                    Source
                  </div>
                </v-col>
                <v-col cols="12" sm="9" md="9" class="pad-col-left">
                  <v-autocomplete
                    ref="source"
                    v-model="storeState.block.source.uuid"
                    :items="uniqueSources"
                    placeholder="Postgres"
                    item-text="name"
                    item-value="block_uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="new-password"
                    class="denser"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <!-- {{item.name}} -->
                        <v-list-item-title v-html="item.name">{{item}}</v-list-item-title>
                        <v-list-item-subtitle v-html="item.db_type"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn text @click="editSources">Edit / remove sources</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </div>
      <div v-if="showTitle" class="search-container2">
        <div @click="backToSearch" class="table-title clickable">{{storeState.block.title}}</div>
        <v-tooltip left dark color="#333">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="tables-run">
              <v-btn icon @click="runTables">
                <v-icon large>
                  mdi-play-circle-outline
                </v-icon>
              </v-btn>
            </span>
          </template>
          <span class="tooltip-text">Run</span>
          <span class="key">
            <span v-if="storeState.isMac" class="key-inner key-inner-icon">
              <v-icon color="#fff !important" size="12">mdi-apple-keyboard-command</v-icon>
            </span>
            <span v-else class="key-inner">
              Ctrl
            </span>
          </span>
          <span class="key">
            <span class="key-inner">enter</span>
          </span>
        </v-tooltip>
        <v-tooltip bottom dark color="#333">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="tables-back">
              <v-btn icon @click="backToSearch">
                <v-icon large>
                  mdi-arrow-left-circle
                </v-icon>
              </v-btn>
            </span>
          </template>
          <span class="tooltip-text">Back</span>
          <span class="key">
            <span class="key-inner">esc</span>
          </span>
        </v-tooltip>
      </div>
      <div v-else class="search-container2">
        <div class="search-underlay">
          <div v-html="underlay"></div>
        </div>
        <div class="search-text-container">
          <textarea 
            placeholder="Search" 
            ref="searchText" 
            v-model="storeState.searchTerm" 
            v-on:keyup="search"
            rows="1" 
            wrap="off" 
            class="search-text mousetrap" 
            spellcheck="false"
          >
          </textarea>
          <v-tooltip left dark color="#333">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="save-search">
                <v-btn icon @click="runTables">
                  <v-icon large>
                    mdi-play-circle-outline
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span class="tooltip-text">Run</span>
            <span class="key">
              <span v-if="storeState.isMac" class="key-inner key-inner-icon">
                <v-icon color="#fff !important" size="12">mdi-apple-keyboard-command</v-icon>
              </span>
              <span v-else class="key-inner">
                Ctrl
              </span>
            </span>
            <span class="key">
              <span class="key-inner">enter</span>
            </span>
          </v-tooltip>
          <!-- <v-tooltip left dark color="#333">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="save-search">
                <v-btn icon @click="backToBlocks">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span class="tooltip-text">Close</span>
            <span class="key">
              <span class="key-inner">esc</span>
            </span>
          </v-tooltip> -->
          <!-- <v-tooltip left dark color="#333">
            <template v-slot:activator="{ on }">
              <button v-on="on" class="soup-btn" @click="backToBlocks">
                <v-icon>mdi-close</v-icon>
              </button>
            </template>
            <span class="tooltip-text">Close</span>
            <span class="key">
              <span class="key-inner">esc</span>
            </span>
          </v-tooltip> -->
        </div>
      </div>
      <div ref="searchSuggestions" class="search-suggestions" v-if="showSuggestions">
        <div v-if="storeState.searchSuggestions.length === 0" class="suggest-explain">
          Find a table
        </div>
        <div ref="suggestionList">
          <div
            :data-uuid="row.suggestionUuid"
            :ref="'suggestion_' + index"
            :id="'suggestion_' + index"
            v-for="(row, index) in storeState.searchSuggestions.slice(0, 10)"
            :key="row.suggestionUuid"
            @mouseover="hoverRow(row, index, true)"
            @mouseleave="hoverRow(row, index, false)"
            :class="{
                'active': (index === storeState.searchIndex), 
                'row-hover': storeState.searchIndex < 0,
                'searchResultRows': true,
                }"
            >
            <v-row>
              <v-col cols="12" sm="4" class="text-left dense-col clickable suggest-title" @click="rowClick" :data-uuid="row.uuid" :data-type="row.type" :data-index="index">
                <v-icon small class="blocks-icon left suggestion-icons">{{ row.icon }}</v-icon>
                {{row.title}}
              </v-col>
              <v-col cols="12" sm="8" class="text-left dense-col clickable" @click="rowClick" :data-uuid="row.uuid" :data-type="row.type" :data-index="index">
                {{row.details}}
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <!-- <v-divider v-if="showSuggestions"></v-divider> -->
      <div class="io-split-container">
        <div class="split-elements">
          <div class="sync-container">
            <v-progress-circular
              v-if="syncing"
              indeterminate
              :size="20"
              :width="5"
              color="primary"
              class="justify-center align-center"
            > 
            </v-progress-circular>
            <v-icon @click="syncChanges" class="clickable" v-else>mdi-database-refresh</v-icon>
            <div v-if="syncing" class="pl-2 sync-text">Syncing...</div>
            <div v-else @click="syncChanges" class="pl-2 sync-text clickable">Sync Changes</div>
          </div>
          <span 
            class="clickable grey50" 
            @click="showSyncs=!showSyncs"
            v-closable="{
              exclude: ['syncList', 'filterList', 'filterBtn'],
              handler: 'hideSyncs'
            }">
            {{storeState.block.tables.syncs.length}} rows waiting to sync
          </span>
          <div class="syncs-list" ref="syncList" v-if="showSyncs">
            <div
              v-for="(sync, index) in storeState.block.tables.syncs"
              :key="index"
            >
              <v-row class="sync-row pl-3">
                <v-col v-if="sync.type === 'insert'" cols="12" sm="10" md="10" class="">
                  insert key <strong>{{sync.row[getPrimaryKey()]}}</strong> as {{sync.row}}
                </v-col>
                <v-col v-else cols="12" sm="10" md="10" class="">
                  <strong>{{sync.item[getPrimaryKey()]}}</strong> ({{getPrimaryKey()}}) {{sync.column}} changed to {{sync.item[sync.column]}}
                </v-col>
                <v-col cols="12" sm="2" md="2" class="text-right pr-4">
                <v-icon @click="removeSync(index)">mdi-close</v-icon>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="split-element-right">
            <div ref="filterBtn" class="clickable inline" @click="showFiltersNow" 
              v-closabletwo="{
                exclude: ['filterList'],
                handler: 'hideFilters'
              }"
            >
              <v-icon :class="{'sw-blue': storeState.block.tables.filters.length > 0}">mdi-filter</v-icon>
              <span :class="{'sw-blue': storeState.block.tables.filters.length > 0}">Filter ({{storeState.block.tables.filters.length}})</span>
            </div>
            <div ref="filterList" class="query-filters" v-if="showFilters">
              <div>
                <div
                  v-for="(filter, index) in storeState.block.tables.filters"
                  :key="index"
                >
                  <v-row class="filter-row">
                    <v-col cols="12" sm="1" md="1" class="pr-0" v-if="index > 0">
                      <v-select
                        :items="andOr"
                        v-model="storeState.block.tables.filters[index].andOr"
                        placeholder="And"
                        single-line
                        dense
                        class="denser"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" :md="index > 0 ? 3 : 4" class="">
                      <v-select
                        v-model="storeState.block.tables.filters[index].field"
                        :items="filterSuggestions"
                        placeholder="Field"
                        item-value="path"
                        return-object
                        auto-select-first
                        single-line
                        autocomplete="new-password"
                        dense
                        class="denser"
                        @change="getFilterOperators"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon>{{item.icon}}</v-icon>
                              <span class="pl-1">{{item.path}}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div>
                            <v-icon>{{item.icon}}</v-icon>
                            {{item.path}}
                          </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="">
                      <v-select
                        :items="tableFilterOperators[index]"
                        v-model="storeState.block.tables.filters[index].operator"
                        item-value="key"
                        item-text="display"
                        placeholder="Operator"
                        return-object
                        single-line
                        dense
                        class="denser"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="" v-if="!noValueOperators.includes(storeState.block.tables.filters[index].operator)">
                      <v-text-field
                        v-model="storeState.block.tables.filters[index].value"
                        placeholder="Value"
                        single-line
                        dense
                        class="denser"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" class="">
                      <v-icon @click="removeFilter(index)">mdi-close</v-icon>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="filter-row clickable row-highlight" @click="addFilter">
                  <div >
                    <v-icon>mdi-plus</v-icon>
                    <span class="pad-span-left">Add filter</span>
                  </div>
                </v-row>
                <v-row class="filter-row clickable row-highlight" @click="applyFilters">
                  <div >
                    <v-icon>mdi-play</v-icon>
                    <span class="pad-span-left">Apply filters</span>
                  </div>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-table-container" v-if="showTable">
        <v-lazy>
          <v-data-table
            v-if="storeState.block.results && !storeState.tableLoading"
            fixed-header
            :hide-default-header="true"
            :show-expand="storeState.dfHasJson"
            single-expand
            :headers="storeState.block.results.headers"
            :items="storeState.block.results.rows"
            :items-per-page="20"
            :loading="storeState.tableLoading"
            :options.sync="tableOptions"
            :mobile-breakpoint="600"
          >
            <template v-slot:header="props">
              <thead class="v-data-table-header">
                <tr>
                  <th
                    v-for="(header, index) in storeState.block.results.headers"
                    :key="index"
                    @click="changeSort(header.value)"
                    class="clickable"
                    @contextmenu.prevent="showContextMenuHeader"
                    :data-header-index="index"
                  >
                    <v-icon small class="header-icon">{{ storeState.iconLookUp[header.dtype] }} </v-icon>
                    {{ header.text }}
                    <v-icon v-if="header.text===tableHasPrimaryKey" small class="key-icon">mdi-key</v-icon>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="props">
              <tr @contextmenu.prevent="showContextMenuNow">
                <td class="text-left" :key="index" v-for="(header, index) in storeState.block.results.headers" :data-key="props.item[getPrimaryKey()]" :data-row-index="props.index"> 
                  <div :class="{'editing-row-cell': (getEdited(props, header, index))}" :data-key="props.item[getPrimaryKey()]" :data-row-index="props.index">
                    <span 
                      v-if="!tableHasPrimaryKey"
                      :data-key="props.item[getPrimaryKey()]"
                      :data-row-index="props.index"
                    >
                      {{ props.item[header.value] }}
                    </span>
                    <span 
                      v-else-if="!(getEdited(props, header, index))"
                      class="clickable"
                      @click="columnRowClick(index, header, props)"
                      :data-key="props.item[getPrimaryKey()]"
                      :data-row-index="props.index"
                    >
                      {{ props.item[header.value] }}
                      <!-- {{ props }} -->
                    </span>
                    <v-text-field
                      v-else
                      v-model="props.item[header.value]"
                      @input="updatingField(props, header.value)"
                      label="Edit"
                      single-line
                      autofocus
                    ></v-text-field>
                  </div>
                </td>
              </tr>
            </template>
            <template slot="progress"></template>
            <template v-slot:no-data>
              No results
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">{{store.filterObject(item)}}</td>
            </template>
            <template slot="loading">
            </template>
          </v-data-table>
        </v-lazy>
        <div v-if="storeState.tableLoading" class="fetching-msg-container">
        <!-- <div v-if="true" class="fetching-msg-container"> -->
          <v-row>
            <v-col class="text-center">
              <div class="dot-pulse-container">
                <div class="dot-pulse"></div> 
              </div>
              <!-- <span class="fetching-msg-code">{{storeState.block.code.slice(0, 200)}}</span> -->
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="chart-container" v-if="showChart">
        <v-row>
          <v-col cols="12" sm="8" class="text-center">
            <div class="text-left pl-5 pt-3">
              <input class="chart-title" ref="chartTitle" v-model="storeState.block.viz.title" placeholder="Untitled">
            </div>
            <template>
              <div class="small-chart">
                <line-chart v-if="storeState.block.viz.type === 'line'" :chart-data="datacollection"></line-chart>
                <bar-chart 
                  v-else-if="storeState.block.viz.type === 'bar'" 
                  :chart-data="datacollection" 
                  :options="storeState.block.viz.chartJsOptions">
                </bar-chart>
              </div>
            </template>
          </v-col>
          <v-col cols="12" sm="4" class="text-center">
            <v-row class="viz-row">
              <v-col cols="12" sm="12" class="text-left">
                <v-select
                :items="storeState.vizOptions.types"
                v-model="storeState.block.viz.type"
                label=""
                > 
                  <template v-slot:selection="data">
                    <div :data-type="data.item.value" class="clickable destination-type">
                      <v-icon small style="margin-top: -2px;" class="dest-type-icon">{{data.item.icon}}</v-icon>
                      <strong class="chart-option-label">{{data.item.label}}</strong>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <div :data-type="data.item.value" class="clickable destination-type">
                      <v-icon small>{{data.item.icon}}</v-icon>
                      <strong class="chart-option-label">{{data.item.label}}</strong>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <span class=""></span>
                <strong>Dimensions</strong>
              </v-col>
            </v-row>
            <v-row 
              v-for="(row, index) in storeState.block.setQueryThings.filter(t => !t.measure)"
              :key="row.suggestionUuid"
              @click="vizRowClick(row)"
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{getTypeIcon(row)}}</v-icon>
                <span :class="{'pl-2': true, 'viz-selected': row.selected}">{{row.label}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <span class=""></span>
                <strong>Measures</strong>
              </v-col>
            </v-row>
            <v-row 
              v-for="(row, index) in storeState.block.setQueryThings.filter(t => t.measure)"
              :key="row.suggestionUuid"
              @click="vizRowClick(row)"
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{getTypeIcon(row)}}</v-icon>
                <span :class="{'pl-2': true, 'viz-selected': row.selected}">{{row.label}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <span class=""></span>
                <strong>Options</strong>
              </v-col>
            </v-row>
            <v-row 
              @click="flipStacked()"
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{storeState.block.viz.stacked ? 'mdi-chart-bar-stacked' : 'mdi-chart-bar'}}</v-icon>
                <span :class="{'pl-2': true}">{{storeState.block.viz.stacked ? 'Stacked' : 'Grouped'}}</span>
              </v-col>
            </v-row>
            <v-row 
              @click="flipFill()"
              class="viz-row"
              v-if="storeState.block.viz.type === 'line'"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{storeState.block.viz.fill ? 'mdi-chart-bar-stacked' : 'mdi-chart-bar'}}</v-icon>
                <span :class="{'pl-2': true}">{{storeState.block.viz.fill ? 'Fill' : 'No Fill'}}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-menu
        v-model="showContextMenu"
        :position-x="contextData.x"
        :position-y="contextData.y"
        absolute
        offset-y
      >
        <v-list>
          <v-list-item
            v-for="(item, index) in contextOptions"
            :key="index"
            @click="item.f()"
          >
            <v-list-item-title>
              <v-icon>{{item.icon}}</v-icon>
              <span class="pl-1">{{item.title}}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-if="false">
        <pre>tableHasPrimaryKey {{tableHasPrimaryKey}}</pre>
        <pre>this.storeState.block {{storeState.block}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce';
import { store } from '../store.js';
import draggable from 'vuedraggable';
import _ from 'lodash';
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'


export default {
  mounted() {
    window.bus.$on('focusEl', (details) => {
      setTimeout(() => {
        let ref = this.$refs[details.el]
        if (ref) ref.focus()
      }, 0);
    });
    setTimeout(() => {
      if (this.storeState.dbMeta) {
        this.getSearchSuggestions({searchTerm: ''})
        this.getFilterSuggestions()
        this.getFilterOperators()
      }
    }, 0);
  },
  data() {
    return {
      storeState: store.state,
      block: store.state.block,
      showTitle: false,
      editedRows: {},
      tableHasPrimaryKey: false,
      tableOptions: {
        sortBy: ''
      },
      showContextMenu: false,
      contextData: {},
      contextOptions: [],
      syncing: false,
      showSidebar: false,
      filterSuggestions: [],
      tableFilterOperators: [],
      // editingPlanType: false,
      linkColor: 'color: rgb(46, 170, 220)',
      andOr: [
        {text: 'And', value: 'and'},
        {text: 'Or', value: 'or'},
      ],
      showFilters: false,
      noValueOperators: ['isNotNull', 'isNull'],
      filterOperators: {
        number: [
          {display: '=', sql: '$field = $value', text: 'Equal to', key: 'equalTo'},
          {display: '≠', sql: '!=', text: 'Not equal to', key: 'notEqualTo'},
          {display: '≥', sql: '>=', text: 'Greater than or equal to', key: 'gte'},
          {display: '≤', sql: '<=', text: 'Less than or equal to', key: 'lte'},
          {display: '>', sql: '>', text: 'Greater than', key: 'gt'},
          {display: '<', sql: '<', text: 'Less than', key: 'lt'},
          {display: 'Null', sql: 'IS NULL', text: 'Null', key: 'isNull'},
          {display: 'Not Null', sql: 'IS NOT NULL', text: 'Not Null', key: 'isNotNull'},
        ],
        string: [
          {display: 'Is', sql: '=', text: 'Is', key: 'notNull'},
          {display: 'Is Not', sql: '!=', text: 'Is not', key: 'notNull'},
          {display: 'Contains', sql: `$field LIKE '%$value%'`, text: 'Contains', key: 'contains'},
          {display: 'Does not contain', sql: `$field NOT LIKE '%$value%'`, text: 'Contains', key: 'notContain'},
          {display: 'Starts With', sql: `$field LIKE '$value%'`, text: 'Contains', key: 'startsWith'},
          {display: 'Ends With', sql: `$field LIKE '%$value'`, text: 'Contains', key: 'endsWith'},
          {display: 'Is Null', sql: `$field IS NULL`, text: 'Is Null', key: 'isNull'},
          {display: 'Is Not Null', sql: '$field IS NOT NULL', text: 'Is Not Null', key: 'isNotNull'},
        ],
        time: [
          {display: 'Is', sql: '$field = $value', text: 'Is', key: 'exactDate'},
          {display: 'Is Within', sql: '$field >= $value', text: 'Is', key: 'dateWithin'},
        ]
      },
      // https://coolors.co/50514f-f25f5c-ffe066-247ba0-70c1b3
      defaultColorScheme: [
        {color: '#F25F5C', nickname: 'red', primary: true},
        {color: '#247BA0', nickname: 'blue', primary: true},
        {color: '#FFE066', nickname: 'yellow', primary: false},
        {color: '#70C1B3', nickname: 'green', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#fff', nickname: 'white', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
      ],
      showTable: true,
      showChart: false,
      showSyncs: false,
      showSql: false,
      datacollection: {},
      store: store,
      searchTerm: store.state.searchTerm,
      showSuggestions: true,
      blockHoverIndex: -1,
      searching: store.state.searching,
      favorites: false,
      scheduled: false,
      searchResults: [],
      searchSuggestions: store.state.searchSuggestions,
      saved: false,
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
    LineChart,
    BarChart,
  },
  watch: {
    'storeState.tableLoading': {
      handler: function (newVal, oldVal) {
        console.log('watch tableLoading', 'newval: ', newVal, '   oldVal:', oldVal)
        this.showSuggestions = false
        // if (!newVal) {
          
        // } 
      }
    },
    'storeState.block.source.uuid': {
        handler: function (newId, oldId) {
          console.log('new source id: ', newId, 'old was: ', oldId)
          if (newId === oldId) return
          let u = this.storeState.allSources.find(s => s.block_uuid === newId)
          let old = this.storeState.allSources.find(s => s.block_uuid === oldId)
          if (u && u.name) {
            if (old && u.name === old.name) return
            this.storeState.block.source.name = u.text || u.name
            this.getExplore(this)
          }
          let source = this.storeState.sources.find(s => s.block_uuid === newId)
          // if (source && source.meta) this.storeState.dbMeta = source.meta
          if (source && source.name) this.storeState.block.source.name = source.name
        },
        deep: false
    },
    'storeState.block.setQuery': {
      handler: function (newVal, oldVal) {
        this.showSuggestions = true
      }
    },
    'storeState.dbMeta': {
      handler: function (newVal, oldVal) {
        this.getSearchSuggestions({searchTerm: ''})
        this.getFilterSuggestions()
        this.getFilterOperators()
      },
      deep: true,
    },
    'storeState.block.tags': {
        handler: function (val, oldVal) {
          console.log('storeState.block.tags: ', val, oldVal)
          var tags = []
          for (let [key, value] of Object.entries(this.storeState.blocks)) {
            let blockTagKeys = value.tags.map(t => t.value)
            let allTagKeys = tags.map(t => t.value)
            let newTags = _.difference(blockTagKeys, allTagKeys)
            if (newTags.length > 0 && newTags[0]) {
              for (let i = 0; i < newTags.length; i++) {
                tags.push(value.tags.find(t => t.value === newTags[i]))
              }
            }
          }
          this.storeState.blockTags = tags
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          console.log('this.storeState.blockTags: ', this.storeState.blockTags)
        },
        deep: true,
    },
    'storeState.block.code': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.tables.filters': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          // this.getFilterOperators()
        },
        deep: true
    },
    'storeState.block.destination': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.source': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.repeat': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.favorite': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.params': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.results.rows': {
        handler: function (val, oldVal) {
          if (this.storeState.block.results.rows.length > 0) {
            store.updateBlock({gotBlock: this.storeState.gotBlock})
          }
          
        },
        deep: true
    },
    'storeState.block.viz': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    getExplore(self) {
      console.log('getExplore...')
      if (!self.storeState.block.source.uuid) return
      if (self.storeState.block.cellType === 'set') return
      let block = JSON.parse(JSON.stringify(self.storeState.block))
      let source = self.storeState.allSources.find(s => s.block_uuid === block.source.uuid)
      block.code = self.storeState.exploreSqlDict[source.db_type]
      block.destination = {}
      block.repeat = {}
      block.limit = 10000
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
      }
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('getExplore done: ', res.data)
            self.storeState.snackbar = true;
            self.storeState.message = 'Explore refreshed!';
            self.storeState.dbMeta = res.data
            let source = self.storeState.sources.find(s => s.block_uuid === self.storeState.block.source.uuid)
            if (source) {
              source.meta = self.storeState.dbMeta 
            }
            self.storeState.dbMeta.tables = []
            self.storeState.dbMeta.tablesNoViews = []
            for (let i = 0; i < self.storeState.dbMeta.df.length; i++) {
              let meta = self.storeState.dbMeta.df[i];
              if (meta.table_schema) {
                var table = `${meta.table_schema}.${meta.table_name}`
              } else {
                var table = `${meta.table_name}`
              }
              if (!self.storeState.dbMeta.tables.includes(table) && meta.table_schema != 'information_schema') {
                self.storeState.dbMeta.tables.push(table)
              }
              if (!self.storeState.dbMeta.tablesNoViews.includes(table) && meta.table_schema != 'information_schema' && meta.is_table>0) {
                self.storeState.dbMeta.tablesNoViews.push(table)
              }
            }
            // self.$parent.getSoupSources()
          } else {
            console.error('getExplore error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = res.data.error;
            self.connectError = res.data.error
          }
        })
        .catch((error) => {
          console.error('getExplore error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    getEdited(props, header, index) {
      let primaryKey = this.getPrimaryKey()
      let edited = this.editedRows[props.item[primaryKey]]
      if (edited && (edited[header.value] || edited[header.value] === 0 || edited[header.value] === "0")) return true
      let inserts = this.storeState.block.tables.syncs.filter(s => s.type === 'insert')
      if (inserts) { //dont add column updates for pending inserts
        let insertKeys = inserts.map(s => s.row[primaryKey])
        if (insertKeys.includes(props.item[primaryKey])) return true
      }
      return false
    },
    duplicateRow() {
      this.changeSort('')
      // this.storeState.block.results.rows.unshift(this.contextData.row)
      this.storeState.block.results.rows.splice(this.contextData.rowIndex, 0, this.contextData.row)
      this.storeState.block.tables.syncs.push({row: this.contextData.row, type: 'insert'})
    },
    showContextMenuNow(e) {
      e.preventDefault()
      this.contextOptions = [
        { title: 'Duplicate', icon: 'mdi-content-copy', f: this.duplicateRow },
        // { title: 'Delete', icon: 'mdi-delete' },
      ],
      console.log('show context', e)
      let key = e.currentTarget.dataset.key || e.target.dataset.key
      let rowIndex = e.currentTarget.dataset.rowIndex || e.target.dataset.rowIndex
      let headerIndex = e.currentTarget.dataset.headerIndex || e.target.dataset.headerIndex
      console.log('show context key', key, rowIndex)
      let primaryKey = this.getPrimaryKey()
      let row = this.storeState.block.results.rows.find(r => r[primaryKey] == key)
      this.contextData.rowIndex = rowIndex
      if (row) {
        this.contextData.row = JSON.parse(JSON.stringify(row));
        this.contextData.row[primaryKey] = 'autogenerate'
        console.log('row to copy', this.contextData.row)
      }
      this.contextData.x = e.clientX
      this.contextData.y = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    showContextMenuHeader(e) {
      e.preventDefault()
      console.log('show context', e)
      this.contextOptions = [
        { title: 'Copy column name', icon: 'mdi-content-copy', f: this.copyColumnName },
        { title: 'Filter', icon: 'mdi-filter', f: this.addFilterFromHeader },
        { title: 'Hide', icon: 'mdi-eye-off-outline', f: this.hideHeader },
      ]
      let headerIndex = e.currentTarget.dataset.headerIndex || e.target.dataset.headerIndex
      let primaryKey = this.getPrimaryKey()
      let header = this.storeState.block.results.headers[Number(headerIndex)]
      this.contextData.header = header
      this.contextData.x = e.clientX
      this.contextData.y = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    changeSort(column) {
      if (this.tableOptions.sortBy === column) {
        this.tableOptions.sortDesc = !this.tableOptions.sortDesc
      } else {
        this.tableOptions.sortBy = column
        this.tableOptions.sortDesc = false
      }
    },
    hideSyncs() {
      this.showSyncs = false
    },
    hideFilters() {
      this.showFilters = false
    },
    columnRowClick(index, header, props) {
      console.log('row: ', index, header, props)
      if (!props.edits) props.edits = {}
      if (!props.edits[header.value]) props.edits[header.value] = {}
      if (!props.edits[header.value].originalValue) props.edits[header.value].originalValue = props.item[header.value]
      console.log('rcolumnRowClick2: ', props)
      this.$set(props, 'edited', true)
      this.$set(props, 'isSelected', true)
      // props.edited = true
      // props.isSelected = true
      let primaryKeyValue = props.item[this.getPrimaryKey()]
      // this.editedRows is dictionary keyed on the primaryKey that contains an object with columnName:originalValue
      let edit = this.editedRows[primaryKeyValue]
      if (edit) {
        edit[header.value] = props.item[header.value]
      } else {
        this.editedRows[primaryKeyValue] = {}
        this.editedRows[primaryKeyValue][header.value] = props.item[header.value]
      }
      // row.item.originalValue = row.value
      this.storeState.block.results.headers = this.storeState.block.results.headers.map(e => ({...e, sortable: false}))
      this.$forceUpdate()
    },
    backToSearch(row, column) {
      this.showTitle = false
      this.showSuggestions = true
      this.getSearchSuggestions({})
      setTimeout(() => {
        this.$refs.searchText.focus()
      }, 0);
    },
    updatingField(row, column) {
      console.log('row updating: ', row, column)
      //get primary key
      let primaryKey = this.getPrimaryKey()
      if (column === primaryKey) {
        let primaryKeyValue = row.item[primaryKey]
        let edit = this.editedRows[primaryKeyValue]
        if (!edit) {
          this.editedRows[primaryKeyValue] = {}
          this.editedRows[primaryKeyValue][column] = row.item[column]
        }
      }
      let inserts = this.storeState.block.tables.syncs.filter(s => s.type === 'insert')
      if (inserts) { //dont add column updates for pending inserts
        let insertKeys = inserts.map(s => s.row[primaryKey])
        if (insertKeys.includes(row.item[primaryKey])) return
      }
      this.storeState.block.tables.syncs = this.storeState.block.tables.syncs.filter(
        s => s.type === 'insert' || (s.item[primaryKey] != row.item[primaryKey] || s.column != column))
      row.column = column
      this.storeState.block.tables.syncs.push(row)
      this.$forceUpdate()
    },
    rowEdited(index, header) {
      let row = this.editedRows[index]
      if (row && row[header.value]) {
        return true
      }
      return false
    },
    showFiltersNow()  {
      this.showFilters = !this.showFilters
      this.getFilterOperators()
      this.$forceUpdate()
    },
    getFilterOperators() {
      console.log('getFilterOperators...')
      if (!this.storeState.block.tables) return
      this.tableFilterOperators = []
      for (let i = 0; i < this.storeState.block.tables.filters.length; i++) {
        let filter = this.storeState.block.tables.filters[i];
        if (!filter.field.python_type) {
          this.tableFilterOperators[i] = this.filterOperators.string
        } else if (filter.field.python_type === 'str') {
          this.tableFilterOperators[i] = this.filterOperators.string
        } else if (['int', 'float'].includes(filter.field.python_type)) {
          this.tableFilterOperators[i] = this.filterOperators.number
        } else if (filter.field.python_type.includes('date') || filter.field.python_type.includes('time')) {
          this.tableFilterOperators[i] = this.filterOperators.time
        } else {
          this.tableFilterOperators[i] = this.filterOperators.string
        }
      }
      this.$forceUpdate()
    },
    getPrimaryKey() {
      for (let [key, obj] of Object.entries(this.storeState.block.tables.metadata)) {
        if (obj.primary_key) return key
      }
      return false
    },
    editSources() {
      console.log('edit source...')
      this.$router.push({ name: 'Sources' }).catch(err => console.error(err))
    },
    removeSync(index) {
      this.storeState.block.tables.syncs.splice(index, 1)
    },
    syncChanges() {
      var self = this
      this.syncing = true
      this.storeState.block.results.headers = this.storeState.block.results.headers.map(e => ({...e, sortable: true}))
      this.$forceUpdate()
      console.log('syncing...', this.storeState.block.tables)
      let primaryKey = this.getPrimaryKey()
      if (this.storeState.block.tables.syncs.length === 0) {
        self.storeState.snackbar = true;
        self.storeState.message = 'No pending changes, edit the table first.';
        this.syncing = false
        return
      }
      for (let i = 0; i < this.storeState.block.tables.syncs.length; i++) {
        let sync = this.storeState.block.tables.syncs[i];
        sync.primaryKey = primaryKey
        if (sync.type === 'insert') {

        } else {
          sync.primaryKeyValue = sync.item[primaryKey]
          sync.updateColumn = sync.column
          sync.newValue = sync.item[sync.column]
        }
      }
      let data = {
        sessionId: this.storeState.sessionId,
        tables: this.storeState.block.tables,
        source: this.storeState.block.source,
      }
      axios.post(store.getPathRunner('/sync_table'), data)
        .then((res) => {
          this.syncing = false
          if (res.data.ok) {
            console.log('sync_table done: ', res.data)
            self.storeState.snackbar = true;
            self.storeState.message = 'Sync complete!';
            if (res.data.updatedRows) self.storeState.message+= ` ${res.data.updatedRows} row(s) updated.`
            for (let i = 0; i < res.data.results.length; i++) {
              let syncResult = res.data.results[i];
              let syncSent = this.storeState.block.tables.syncs[i]
              if (syncSent.type === 'insert') {
                let primaryKey = this.getPrimaryKey()
                if (syncSent.row[primaryKey] === 'autogenerate') {
                  syncSent.row[primaryKey] = syncResult.result.primaryKey[0]
                }
              }

            }
          } else {
            console.error('sync_table error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = res.data.error;
          }
          this.storeState.block.tables.syncs = []
          this.editedRows = []
        })
        .catch((error) => {
          this.storeState.block.tables.syncs = []
          this.editedRows = []
          console.error('sync_table error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
      // this.storeState.block.tables.syncs = []
    },
    saveRow(row) {
      console.log('row: ', row)
    },
    keydownRow(row) {
      console.log('row: ', row)
    },
    cancelRow(row) {
      console.log('row: ', row)
    },
    openRow(row) {
      console.log('row: ', row)
    },
    closeRow(row) {
      console.log('row: ', row)
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    goToSql() {
      this.$router.push({ name: 'Run', params: {id: this.storeState.block.uuid }}).catch(err => console.error(err))
    },
    runTables() {
      let sql = store.generateMetaSql2(this.storeState.block.tables)
      this.storeState.block.code = sql
      store.runCode({})
      this.showSyncs = false
      this.showFilters = false
      this.showSuggestions = false
      this.showTitle = true
    },
    applyFilters() {
      let sql = store.generateMetaSql2(this.storeState.block.tables)
      this.storeState.block.code = sql
      store.runCode({})
      this.showFilters = false
    },
    copyColumnName() {
      this.$copyText(this.contextData.header.text)
      this.storeState.snackbar = true;
      this.storeState.message = `Copied ${this.contextData.header.text}`;
    },
    addFilterFromHeader() {
      this.addFilter({field: this.contextData.header.text})
      this.showFilters = true
    },
    hideHeader() {
      this.storeState.block.results.headers = this.storeState.block.results.headers.filter(h => h.text != this.contextData.header.text)
    },
    addFilter(opts) {
      var opts = opts || {}
      let filter = {
        andOr: false,
        field: '',
        operator: '=',
        value: '',
      }
      if (this.storeState.block.tables.filters.length > 0) {
        filter.andOr = 'and'
      }
      if (opts.field) {
        filter.field = this.filterSuggestions.find(f => f.text === opts.field)
      } else {
        filter.field = this.filterSuggestions[0]
      }
      this.storeState.block.tables.filters.push(filter)
      let filterLen = this.storeState.block.tables.filters.length
      this.getFilterOperators()
      if (this.tableFilterOperators.length > 0) {
        filter.operator = this.tableFilterOperators[filterLen-1][0]
      }
    },
    removeFilter(index) {
      this.storeState.block.tables.filters.splice(index, 1)
    },
    flipStacked() {
      this.storeState.block.viz.stacked = !this.storeState.block.viz.stacked
      if (this.storeState.block.viz.stacked) {
        this.storeState.block.viz.chartJsOptions.scales = {
          xAxes: [{
              stacked: true
          }],
          yAxes: [{
              stacked: true
          }]
        }
      } else {
        this.storeState.block.viz.chartJsOptions = {}
      }
      this.$forceUpdate()
      this.makeChart()
    },
    flipFill() {
      this.storeState.block.viz.fill = !this.storeState.block.viz.fill
      this.$forceUpdate()
      this.makeChart()
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getTypeIcon(row) {
      if (row.measure) return 'mdi-pound'
      if (!row.type) return 'mdi-format-text'
      return this.storeState.iconLookUp[row.type]
    },
    vizRowClick(row) {
      let changed = this.storeState.block.setQueryThings.findIndex(q => q.suggestionUuid === row.suggestionUuid)
      this.storeState.block.setQueryThings[changed].selected = !this.storeState.block.setQueryThings[changed].selected
      this.makeChart()
      this.$forceUpdate()
    },
    fillData () {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    },
    showTableNow() {
      this.showTable = true
      this.showChart = false
    },
    showChartNow() {
      this.showTable = false
      this.showChart = true
    },
    getDimensionsMeasures(d) {
      let dimensions = []
      let measures = []
      for (let [key, obj] of Object.entries(d[0])) {
        let setInfo = this.storeState.block.setQueryThings.find(t => t.label === key)
        if (!setInfo && key === 'Count') {
          console.log('found the count: ', )
          measures.push({
            "label": "Count",
            "measure": true,
            "type": "count",
            "data": []
          })
        } else if (setInfo.measure) {
          console.log('found measure: ', setInfo)
          setInfo.data = []
          measures.push(setInfo)
        } else {
          dimensions.push(setInfo)
        }
      }
      return {dimensions: dimensions, measures: measures}
    },
    getChartLabels(d, dm) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        rows.push(row[dm.dimensions[0].label])
      }
      return rows
    },
    getChartData(d, dm) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        // dm.measures[i].data = []
        for (let i2 = 0; i2 < dm.measures.length; i2++) {
          dm.measures[i2].data.push(row[dm.measures[i2].label])
        }
      }
      for (let i = 0; i < dm.measures.length; i++) {
        let el = dm.measures[i];
        if (el.selected) {
          var color = this.defaultColorScheme[i].color
          if (!color) color = this.getRandomColor()
          rows.push({
            label: el.label,
            backgroundColor: color,
            borderColor: color,
            data: el.data,
            fill: this.storeState.block.viz.fill
          })
        }
      }
      return rows
    },
    makeChart() {
      console.log('make chart')
      let dm = this.getDimensionsMeasures(this.storeState.block.results.rows)
      this.datacollection = {
        labels: this.getChartLabels(this.storeState.block.results.rows, dm),
        datasets: this.getChartData(this.storeState.block.results.rows, dm),
      }
    },
    backToBlocks() {
      this.storeState.searching = false
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    fromNowRunFormat: function (data) {
      if (!data) return 'Never run'
      return moment(data/1000).fromNow()
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
    },
    runBlock(block) {
      this.$parent.openBlock(block.uuid)
    },
    getSourceName(row) {
      let s = this.storeState.allSources.find(s => s.block_uuid === row.source.uuid)
      if (s && s.name) return `${s.name}`
      return ''
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    getBlock(uuid) {
      console.log('getBlock: ', uuid)
      this.storeState.noAccess = false
      this.storeState.gotBlock = false
      if (this.storeState.gotBlocks) {
        var block = this.storeState.blocks[uuid]
        if (block) {
          console.log('getBlock2: ', block)
          block.viewedOn = moment.unix(moment()).utc()._i
          block = store.addMissingBlockAttributes(block)
          this.storeState.block = block
          if (block.destination.sheet && this.storeState.destinations.sheets.length === 0) {
            this.storeState.destinations.sheets.push(block.destination.sheet)
          }
          if (block.tables.metadata) {
            this.getFilterSuggestions()
          }
          this.storeState.gotBlock = true
          setTimeout(() => {
            this.$refs.searchText.focus()
          }, 1);
        } else if (this.storeState.newBlocks.includes(uuid)) {
          // this.editDestination = true
          // this.editRepeat = true
          // changeSource
          
          this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
          this.storeState.block.uuid = uuid
          if (this.storeState.setSourceId) {
            this.storeState.block.source.uuid = this.storeState.setSourceId
            this.storeState.setSourceId = false
          } else {
            this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
          }
          this.storeState.gotBlock = true
          setTimeout(() => {
            this.$refs.searchText.focus()
          }, 1);
        } else {
          this.storeState.noAccess = true
          console.log('you dont have access to this block')
        }
      } else {
        // setTimeout(this.getBlock(uuid), 100)
        setTimeout(() => {
            this.getBlock(uuid)
        }, 500);
      }
      this.getBlockHistory()
    },
    getBlockHistory(uuid) {
      let blockLs = Object.keys(this.storeState.blocks).map(id => this.storeState.blocks[id])
      blockLs = blockLs.sort((a, b) => a.viewOn - b.viewOn);
      this.storeState.blockHistory = blockLs.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 10)
      console.log('this.storeState.blockHistory: ', this.storeState.blockHistory)
    },
    updateUnderlay(suggestion) {
      this.storeState.block.setQuery = this.storeState.block.setQuery.replace(this.storeState.searchTerm, '')
      this.storeState.block.setQuery += suggestion.path + '  '
      // let html = ''
      // html+= `<span class="term-underlay" data-uuid="${suggestion.suggestionUuid}">${suggestion.path}</span>`
      // this.underlay = html
      this.updateUnderlayKeydown()
    },
    updateUnderlayKeydown() {
      let searchTermParts = this.storeState.block.setQuery.split(/(\s+)/)
      this.storeState.searchTerm = ''
      let html = ''
      // this.storeState.block.setQueryThings = []
      let currentMatches = []
      for (let i = 0; i < searchTermParts.length; i++) {
        let term = searchTermParts[i];
        let termMatch = this.underlayTerms.find(t => t.path === term)
        if (termMatch) {
          html+= `<span class="term-underlay" data-uuid="${termMatch.suggestionUuid}">${termMatch.path}</span>`
          termMatch
          let alreadyMatched = this.storeState.block.setQueryThings.find(t => t.path === term)
          if (!alreadyMatched) {
            termMatch.selected = true
            this.storeState.block.setQueryThings.push(termMatch)
          }
          currentMatches.push(termMatch.path)
        } else {
          this.storeState.searchTerm += term
          html+= `<span class="term-underlay term-underlay-text">${term}</span>`
        }
      }
      this.storeState.block.setQueryThings = this.storeState.block.setQueryThings.filter(t => currentMatches.includes(t.path))
      this.storeState.searchTerm = this.storeState.searchTerm.replace(/\s+/g,' ').trim();
      this.underlay = html
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      let suggestion = self.storeState.searchSuggestions[e.currentTarget.dataset.index]
      let sql = store.generateMetaSql(suggestion)
      this.storeState.block.code = sql
      this.storeState.block.queryBuilder = true
      if (!this.storeState.block.source.uuid) this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
      this.storeState.block.tables.table = suggestion
      this.storeState.block.tables.tableName = suggestion.sql.table
      this.hideSearch()
      this.storeState.block.tables.schemaName = false
      if (suggestion.sql.table.includes('.')) {
        let parts = suggestion.sql.table.split('.')
        this.storeState.block.tables.tableName = parts[parts.length-1]
        this.storeState.block.tables.schemaName = parts[0]
      }
      this.getTableMetadata()
      this.showSuggestions = false
      this.storeState.searchSuggestions = []
      store.runCode({})
    },
    hideSearch() {
      this.storeState.block.tables.filters = []
      this.showSuggestions = false
      this.showTitle = true
      this.storeState.block.tables.syncs = []
      this.storeState.block.title = this.storeState.block.tables.tableName
      this.storeState.searchTerm = this.storeState.block.tables.tableName
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    openSettings() {
      this.storeState.cmdkParentCmd = 'settings'
      this.$parent.openCmdK({cmdkParentCmd: 'settings', cmdkInput: ''})
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      console.log('newBlocks: ', this.storeState.newBlocks)
      this.$router.push({ name: 'Run', params: {id:  blockId}}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    filterBlocks(opts) {
      var blockResults = []
      opts.searchTerm = opts.searchTerm.toLowerCase()
      for (const blockId in this.storeState.blocks) {
        let block = this.storeState.blocks[blockId]
        if (block.code.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        } else if (block.title.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        }
      }
      blockResults = blockResults.slice(0, 5)
      return blockResults.sort((a, b) => { return a.viewedOn - b.viewedOn;})
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchIn = searchIn.toLowerCase()
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * startMatch) * 1.0 / searchTermLen
      return {include: include, matches: matches, ratio: ratio}
    },
    getSearchSuggestions(opts) {
      this.storeState.searchSuggestions = []
      let searchTerm = opts.searchTerm || this.storeState.searchTerm
      //add tables
      var i = 0
      let tables = []
      if (!this.storeState.dbMeta.tablesNoViews) {
        this.$parent.refreshMeta()
      }
      while ((i < this.storeState.dbMeta.tablesNoViews.length) && this.storeState.searchSuggestions.length < 100) {
        let table = this.storeState.dbMeta.tablesNoViews[i];
        let match = this.everyLetterMatch(searchTerm, table)
        if (match.include) {
          let suggestion = {
            title: table,
            details: `table in ${table}`,
            icon: 'mdi-table',
            uuid: `${table}`,
            sql: {table: `${table}`},
            type: 'table',
          }
          if (match.ratio > 1) {
            this.storeState.searchSuggestions.push(suggestion)
          } else {
            tables.push(suggestion)
          }
        }
        i++
      }
      tables.sort((a, b) => { return b.ratio - a.ratio;})
      this.showSuggestions = true
      this.storeState.searchSuggestions = this.storeState.searchSuggestions.concat(tables.slice(0, 100 - this.storeState.searchSuggestions.length))
    },
    getFilterSuggestions() {
      if (!this.storeState.block.tables) return
      if (!this.storeState.block.tables.metadata) return
      this.filterSuggestions = []
      for (let [key, obj] of Object.entries(this.storeState.block.tables.metadata)) {
        if (key && obj) {
          if (typeof(obj) != 'boolean') {
            obj.path = `${key}`
            obj.text = `${key}`
            obj.value = `${key}`
            obj.icon = this.storeState.iconLookUp[obj.python_type]
            this.filterSuggestions.push(obj)
          }
        }
      }
    },
    getTableMetadata() {
      console.log('getTableMetadata...')
      var self = this
      let data = {
        sessionId: self.storeState.sessionId,
        block: self.storeState.block,
      }
      axios.post(store.getPathRunner('/get_table_metadata'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('get_table_metadata done: ', res.data)
            self.storeState.block.tables.metadata = res.data
            self.tableHasPrimaryKey = self.getPrimaryKey()
            if (!self.tableHasPrimaryKey) {
              self.storeState.snackbar = true;
              self.storeState.message = 'Table has no primary key, you need to add one to edit contents.';
            } else {
              self.storeState.snackbar = true;
              self.storeState.message = 'Got table metadata!';
            }
            self.getFilterSuggestions()
            self.getFilterOperators()
          } else {
            console.error('get_table_metadata error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = res.data.error;
            self.connectError = res.data.error
          }
        })
        .catch((error) => {
          console.error('get_table_metadata error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.storeState.searchTerm, e)
      if ([13].includes(e.keyCode)) {
        // e.preventDefault() //already done in App.vue
        console.log('hit enter handleEnter...')
        let suggestion = self.storeState.searchSuggestions[self.storeState.searchIndex]
        
        let sql = store.generateMetaSql(suggestion)
        this.storeState.block.code = sql
        this.storeState.block.queryBuilder = true
        if (!this.storeState.block.source.uuid) this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
        this.storeState.block.tables.table = suggestion
        this.storeState.block.tables.tableName = suggestion.sql.table
        this.storeState.block.tables.schemaName = false
        this.hideSearch()
        if (suggestion.sql.table.includes('.')) {
          let parts = suggestion.sql.table.split('.')
          this.storeState.block.tables.tableName = parts[parts.length-1]
          this.storeState.block.tables.schemaName = parts[0]
        }
        this.getTableMetadata()
        this.showSuggestions = false
        this.storeState.searchSuggestions = []
        store.runCode({})
        return
      }
      let opts = {searchTerm: this.storeState.searchTerm}
      this.getSearchSuggestions(opts)
      // this.filterBlocks(opts)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  computed: {
    uniqueSources: function () {
      if (!this.storeState.block || !this.storeState.block.source) return []
      let result = []
      let uniqueNickNames = []
      if (this.storeState.block.source.uuid) {
        let curS = this.storeState.allSources.find(o => o.block_uuid === this.storeState.block.source.uuid)
        if (curS) {
          result.push(curS)
          uniqueNickNames.push(curS.name)
        }
      }
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name)) {
          uniqueNickNames.push(source.name)
          result.push(source)
        }
      }
      result = result.concat(this.storeState.sets)
      return result
    },
  },
  created() {
    store.updateBlock = debounce(store.updateBlock, 500)
    this.getBlock(this.$route.params.id)
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search-q {
  float: right;
  margin-top: -35px;
  margin-right: 26px;
}
.block-search {
  float: right;
  margin-top: -35px;
  margin-right: 3px;
}
.search-container2 {
  padding-top: 20px;
  margin-left: 40px;
  margin-bottom: 20px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
  white-space: pre;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-queue-container {
  margin-left: 0px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.row-title {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-pic {
  display: inline;
}
.row-code {
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-last-run {
  color: rgba(0, 0, 0, 0.5);
  float: right;
}
.block-icons {
  float: right;
}
.blocks-icon {
}
.sw-button {
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Rubik";
  border-radius: 4px;
  text-align: center;
  background: #19774d;
  border: solid 1px #19774d;
  color: white;
  font-size: 0.875rem;
  text-decoration: none;
  padding: 0 1.5rem;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.sw-button:hover {
  background-color: #50a779;
  border-color: #50a779;
}
.v-tab {
  min-width: 0px !important;
  padding-right: 46px !important;
  font-size: 20px !important;
  text-transform: none !important;
}
.left {
  float: left;
}
.nopad {
  padding-bottom: 0px !important;
  padding-top: 8px !important;
}
.favorite {
  padding-right: 10px !important;
  margin-top: 1px;
}
.search-suggestions {
  padding-top: 50px;
}
.dense-col {
  padding-left: 0px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestion-icons {
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: 2px;
  padding-right: 5px !important;
}
.suggest-explain {
  padding-left: 40px;
}
.suggest-title {
  padding-left: 8px;
}
.io-split-container {
  margin-top: 40px;
  height: 65px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.split-elements {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 28px;
}
.split-elements-right {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 28px;
}
.split-element {
  display: inline-block;
  padding-right: 1rem;
  cursor: pointer;
  font-weight: 700;
}
.split-element-right {
  display: inline-block;
  padding-right: 1rem;
  font-weight: 700;
  float: right;
}
.sync-container {
  display: inline-block;
  padding-right: 1rem;
  font-weight: 700;
}
.search-table-container {
  padding-top: 0px;
}
.fetching-msg-code {
  /* background: #F5F7FA; */
  color: #666;
  padding: 5px;
  font-family: monospace;
  display: inline;
  word-wrap: break-word;
}
.dot-pulse {
  position: relative;
  display: inline-block;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
  box-shadow: 9999px 0 0 -5px #212529;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px #212529;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px #212529;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: .5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9984px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9999px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 10014px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
}
.dot-pulse-container {
  display: inline-block;
  margin-right: 30px;
  margin-left: 30px;
}
.v-select__selections {
  padding-left: 10px;
}
.chart-option-label {
  padding-left: 1em;
}
.sw-strong {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}
.viz-row:hover {
  background-color: #F5F7FA;
}
.row-highlight:hover {
  background-color: #F5F7FA;
}
.viz-selected {
  font-weight: bold;
}
.chart-title {
  font-size: 24px;
  font-weight: 700;
  width: 100%;
  padding-right: 10px;
}
.filter-row {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 1em;
  padding-top: .5em;
  padding-bottom: .5em;
}
.syncs-list {
  position: absolute;
  z-index: 4;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  min-width: 800px;
  background-color: #fff;
}
.link-color {
  color: rgb(46, 170, 220);
}
.sw-button-plain {
  background: #FFFFFF;
  border: 1px solid #CBD2D9;
  box-sizing: border-box;
  border-radius: 3px;
}
.inline {
  display: inline;
}
.editing-row-cell {
  height: 100%;
  width: auto;
  margin-left: -16px;
  margin-right: -16px;
  margin-top: -4px;
  background-color:#ffefae;
  padding-left: 16px;
  padding-right: 16px;
}
.sidebar-menu-container {
  /* position: absolute; */
}
.sidebar-menu-icon-container {
  position: absolute;
  margin-top: 17px;
  margin-left: -8px;
  transition: 0.2s;
}
.sidebar-menu-icon-container:hover {
  margin-left: -2px;
}
.sw-blue--text {
  color: rgb(46, 170, 220) !important;
}
.sw-blue {
  color: rgb(46, 170, 220) !important;
}
.sync-text {
  width: 125px;
  display: inline-block;
}
.tables-run {
  float: right;
  margin-top: -35px;
  margin-right: 1.5rem;
}
.tables-back {
  float: right;
  margin-top: -35px;
  margin-right: 2rem;
}
</style>